export const decimalToCents = (payment) => {
  return Math.floor(
    100 * (parseFloat(`${payment}`.replace(/[^\d.]/g, '')) || 0),
  );
};
